import SuperJSON from "superjson";
import Big from "big.js";

SuperJSON.registerCustom<Big, string>({
  isApplicable: (v): v is Big => v instanceof Big,
  serialize   : v => v.toFixed(),
  deserialize : v => new Big(v),
}, "big.js")
